import styles from "./NewYearCard_Reusable.module.css";

import gallery_icon from "../../../assets/images/icons/gallery_ace.svg";

import { Helmet } from "react-helmet";

import React, { useState } from "react";

import EditScreenSelector from "../../Reusables/EditScreenSelector";
import { Link, scroller } from "react-scroll";
const NewYearCard = React.forwardRef(
  (
    {
      index,
      callback,
      callbackPreviewChange,
      state,
      image_selection_popup,
      //new stuff
      saveThisProduct,
      changeCopyDetails,
      selectedCopyDetails,
      currentPageNumber,
      totalPageNumber,
      confirmEdits,
      generatePreviewsAtBottom,
      preview_copied_image,
    },
    ref
  ) => {
    <Helmet>
      <script>
        {`
   (function(d) {
    var config = {
      kitId: 'tnx5lwp',
      scriptTimeout: 3000,
      async: true
    },
    h=d.documentElement,t=setTimeout(function(){h.className=h.className.replace(/\bwf-loading\b/g,"")+" wf-inactive";},config.scriptTimeout),tk=d.createElement("script"),f=false,s=d.getElementsByTagName("script")[0],a;h.className+=" wf-loading";tk.src='https://use.typekit.net/'+config.kitId+'.js';tk.async=true;tk.onload=tk.onreadystatechange=function(){a=this.readyState;if(f||a&&a!="complete"&&a!="loaded")return;f=true;clearTimeout(t);try{Typekit.load(config)}catch(e){}};s.parentNode.insertBefore(tk,s)
  })(document);
  `}
      </script>
    </Helmet>;
    const {
      name,
      firstName,
      postcode,
      address,
      wording,
      customWording,
      otherRequests,
      radioMainType,
      images,
    } = state;

    const changeState = (key, value) => {
      state[key] = value;
      callback(state);
    };
    const allImagesPicked = () => {
      let current = images.reduce((total, item) => total + item.count, 0);
      if (radioMainType.includes(3) && current < 3) {
        return false;
      }
      if (radioMainType.includes(1) && current === 0) {
        return false;
      }
      return true;
    };
    const imgPickedCount = () => {
      return images.reduce((total, item) => total + item.count, 0);
    };
    const uploadImage = () => {
      if (radioMainType.includes(3)) {
        image_selection_popup(index, 3 - imagePicked);
      } else {
        image_selection_popup(index, 1);
      }
    };

    const changeStateMultiple = (keys, values) => {
      for (let i = 0; i < keys.length; i++) {
        state[keys[i]] = values[i];
      }
      callback(state);
    };
    const imagePicked = imgPickedCount();

    //new 1
    const copyOptions = [];
    for (let i = 1; i < currentPageNumber; i++) {
      copyOptions.push(i + "個目と同じ");
    }
    copyOptions.push("別のデザインで作る");
    // let copySelected =
    //   selectedCopyDetails === currentPageNumber
    //     ? currentPageNumber + "個目の写真"
    //     : selectedCopyDetails+"個目の写真";
    let copySelected = selectedCopyDetails + "個目の写真";
    const extractNumber = (s, currentPageNumber, totalPageNumber) => {
      for (let i = totalPageNumber; i > 0; i--) {
        if (s.includes(i)) {
          return i;
        }
      }
      return currentPageNumber;
    };
    return (
      <div className={styles.main_div}>
        <div className={styles.top_hr}></div>
        <div className={styles.header_section_main}>
          {currentPageNumber === 1 && (
            <div name="編　集" className={styles.header_section}>
              編　　集
            </div>
          )}

          {totalPageNumber > 1 && (
            <div
              className={styles.header_number}
              name={"editsection" + currentPageNumber}
            >
              {currentPageNumber + "個目"}
            </div>
          )}
        </div>
        {currentPageNumber > 1 && (
          <div className={styles.multi_page_selector_wrapper}>
            <div className={styles.multi_page_selector}>
              <EditScreenSelector
                takeupspace={true}
                options={copyOptions}
                callback={(value) => {
                  console.log(value);
                  changeCopyDetails(
                    extractNumber(value, currentPageNumber, totalPageNumber),
                    index
                  );
                  // changeState("sec03textbox", value);
                  // setSec03textbox(value);
                }}
                selected={copySelected}
              />
            </div>
          </div>
        )}
        {selectedCopyDetails === currentPageNumber && (
          <>
            <div className={styles.form_main_div01}>
              <div className={styles.from_main_text01}>
                1.年賀状のパターンを選択してください
              </div>
              <div className={styles.radio_section_01}>
                <div className={styles.radio_section}>
                  <div className={styles.element}>
                    <div className={styles.radio_button}>
                      <input
                        className={styles.radio}
                        type="radio"
                        name={"main" + index}
                        checked={radioMainType === "パターンA1枚"}
                        onClick={(event) => {
                          changeState("radioMainType", "パターンA1枚");
                        }}
                      />
                    </div>
                    <div className={styles.radio_text}>パターンA1枚</div>
                  </div>
                  <div className={styles.element}>
                    <div className={styles.radio_button}>
                      <input
                        className={styles.radio}
                        type="radio"
                        name={"main" + index}
                        checked={radioMainType === "パターンA3枚"}
                        onClick={(event) => {
                          changeState("radioMainType", "パターンA3枚");
                        }}
                      />
                    </div>
                    <div className={styles.radio_text}>パターンA3枚</div>
                  </div>
                  <div className={styles.element}>
                    <div className={styles.radio_button}>
                      <input
                        className={styles.radio}
                        type="radio"
                        name={"main" + index}
                        checked={radioMainType === "パターンB1枚"}
                        onClick={(event) => {
                          changeState("radioMainType", "パターンB1枚");
                        }}
                      />
                    </div>
                    <div className={styles.radio_text}>パターンB1枚</div>
                  </div>
                  <div className={styles.element}>
                    <div className={styles.radio_button}>
                      <input
                        className={styles.radio}
                        type="radio"
                        name={"main" + index}
                        checked={radioMainType === "パターンB3枚"}
                        onClick={(event) => {
                          changeState("radioMainType", "パターンB3枚");
                        }}
                      />
                    </div>
                    <div className={styles.radio_text}>パターンB3枚</div>
                  </div>
                </div>
              </div>
              <div className={styles.from_main_text01}>
                2.年賀状に掲載する情報をご記入ください
              </div>
              <div className={styles.form_input_row1}>
                <div className={styles.form_input_label_text}>お名前/姓</div>
                <input
                  className={styles.form_input_text_01}
                  type="text"
                  placeholder=""
                  value={name}
                  onChange={(e) => {
                    changeState("name", e.target.value);
                  }}
                />
              </div>
              <div className={styles.form_input_row2}>
                <div className={styles.form_input_label_text}>お名前/姓</div>
                <input
                  className={styles.form_input_text_2}
                  type="text"
                  placeholder=""
                  value={firstName}
                  onChange={(e) => {
                    changeState("firstName", e.target.value);
                  }}
                />
              </div>
              <div className={styles.form_input_row2}>
                <div className={styles.form_input_label_text}></div>
                <div className={styles.form_info_div01}>
                  ※記載希望順に記入し、名前と名前の間に「・」をお願いいたします。例）太郎・花子
                </div>
              </div>
              <div className={styles.form_input_row1}>
                <div className={styles.form_input_label_text}>郵便番号</div>
                <input
                  className={styles.form_input_text_01}
                  type="text"
                  placeholder=""
                  value={postcode}
                  onChange={(e) => {
                    changeState("postcode", e.target.value);
                  }}
                />
              </div>
              <div className={styles.form_input_row2}>
                <div className={styles.form_input_label_text}>ご住所</div>
                <input
                  className={styles.form_input_text_3}
                  type="text"
                  placeholder=""
                  value={address}
                  onChange={(e) => {
                    changeState("address", e.target.value);
                  }}
                />
              </div>
              <div className={styles.form_input_row5}>
                <div className={styles.form_input_label_text}>文言</div>

                <div className={styles.radio_section02}>
                  <div className={styles.element0}>
                    <div className={styles.radio_button}>
                      <input
                        className={styles.radio}
                        type="radio"
                        name={"secondary" + index}
                        checked={
                          wording ===
                          "昨年は大変お世話になりました 本年もどうぞよろしくお願い申し上げます"
                        }
                        onChange={(event) => {
                          changeState(
                            "wording",
                            "昨年は大変お世話になりました 本年もどうぞよろしくお願い申し上げます"
                          );
                        }}
                      />
                    </div>
                    <div className={styles.radio_text}>
                      昨年は大変お世話になりました
                      本年もどうぞよろしくお願い申し上げます
                    </div>
                  </div>
                  <div className={styles.element}>
                    <div className={styles.radio_button}>
                      <input
                        className={styles.radio}
                        type="radio"
                        name={"secondary" + index}
                        checked={
                          wording ===
                          "新しい家族が増えました 本年もどうぞよろしくお願い申し上げます"
                        }
                        onChange={(event) => {
                          changeState(
                            "wording",
                            "新しい家族が増えました 本年もどうぞよろしくお願い申し上げます"
                          );
                        }}
                      />
                    </div>
                    <div className={styles.radio_text}>
                      本年もどうぞよろしくお願い申し上げます
                    </div>
                  </div>
                  <div className={styles.element}>
                    <div className={styles.radio_button}>
                      <input
                        className={styles.radio}
                        type="radio"
                        name={"secondary" + index}
                        checked={wording === "その他（40字以内）"}
                        onChange={(event) => {
                          changeState("wording", "その他（40字以内）");
                        }}
                      />
                    </div>
                    <div className={styles.radio_text}>その他（40字以内）</div>
                  </div>
                </div>
              </div>
              {wording === "その他（40字以内）" && (
                <div className={styles.form_input_row6}>
                  <div className={styles.form_input_label_text}></div>
                  <div className={styles.form_input_text_area}>
                    <textarea
                      placeholder="その他の場合ご記入ください"
                      type="textbox"
                      rows="2"
                      //   value={titleText}
                      value={customWording}
                      onChange={(e) => {
                        changeState("customWording", e.target.value);
                        // setTitleText(e.target.value);
                      }}
                      className={styles.section02inputbox}
                    ></textarea>
                  </div>
                </div>
              )}
              <div className={styles.form_input_row7}>
                <div className={styles.form_input_label_text}>その他ご要望</div>
                <div className={styles.form_input_text_area}>
                  <textarea
                    placeholder="何かご要望があればご記入ください"
                    type="textbox"
                    rows="3"
                    //   value={titleText}
                    value={otherRequests}
                    onChange={(e) => {
                      // changeState("titleText", e.target.value);
                      // setTitleText(e.target.value);
                      changeState("otherRequests", e.target.value);
                    }}
                    className={styles.section02inputbox}
                  ></textarea>
                </div>
              </div>
            </div>

            <div className={styles.edit_title_text_05}>
              3.年賀状に使用する写真を選択してください。
            </div>

            <div
              onClick={(event) => {
                console.log(allImagesPicked());
                if (allImagesPicked()) return;
                // setImageArray(...imgArray, {
                //   count: 1,
                //   src: sampleArray[Math.floor(Math.random() * sampleArray.length)],
                // });
                uploadImage();
              }}
              className={styles.upload_image_placeholder}
            >
              <img
                className={styles.upload_image_gallery_icon}
                src={gallery_icon}
                alt="top_gallery"
              />

              <div className={styles.upload_image_placeholder_text}>
                写真選択
              </div>
            </div>
            <div className={styles.edit_title_text_002}>
              4.大きくする写真にチェックを入れてください。
            </div>
            <div className={styles.spacing01}></div>
            <div className={styles.image_container_main}>
              {images.map((item, index) => {
                if (item.src === "" || item.count === 0) return null;
                return (
                  <div className={styles.image_single_container} key={index}>
                    <div
                      className={styles.image_main_div}
                      style={{
                        backgroundColor: item.selected
                          ? "rgba(85, 146, 208, 0.23)"
                          : "rgba(204, 204, 204, 0.23)",
                      }}
                    >
                      <img
                        src={item.src}
                        className={styles.edit_image}
                        alt="edit img"
                      />
                      <div
                        onClick={() => {
                          console.log("Cross the image");

                          let temp = JSON.parse(JSON.stringify(images));
                          temp[index].count = 0;
                          temp[index].src = "";
                          changeState("images", temp);
                          // setImageArray(imgArray.filter((item, i) => index !== i));
                        }}
                        className={styles.cross_div}
                      >
                        <ion-icon
                          className={styles.cross_icon}
                          name="close"
                        ></ion-icon>
                      </div>
                      {radioMainType.includes(3) && (
                        <div className={styles.photo_checkbox_text02_checkbox}>
                          <input
                            type="checkbox"
                            className={styles.photo_checkbox_input}
                            checked={item.selected}
                            onChange={() => {
                              let temp = JSON.parse(JSON.stringify(images));
                              for (let i = 0; i < 3; i++) {
                                temp[i].selected = false;
                              }
                              temp[index].selected = true;

                              changeState("images", temp);
                            }}
                          />
                        </div>
                      )}
                      {item.selected && radioMainType.includes(3) && (
                        <div className={styles.caption_text}>
                          大きくする写真
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
            {/* <div className={styles.images_picked_main_div}>
              現在、合計枚数は
              <div className={styles.image_picked_number}>
                {imgPickedCount()}
              </div>
              枚です。
            </div> */}
          </>
        )}
        <div className={styles.confirm_edits_wrapper}>
          <div className={styles.confirm_edits}>
            <div className={styles.confirm_header}>
              上記の内容でデザイン決定しますか？
            </div>
            <div className={styles.confirm_button_section}>
              <Link
                to={
                  totalPageNumber === 1
                    ? "編　集"
                    : "editsection" + currentPageNumber
                }
                spy={true}
                smooth={true}
                offset={-100}
                duration={500}
              >
                <button className={styles.confirm_button_no}>編集へ戻る</button>
              </Link>
              <button
                onClick={() => {
                  if (totalPageNumber === 1) {
                    confirmEdits();
                  } else {
                    if (currentPageNumber < totalPageNumber) {
                      const elementName =
                        "editsection" + (currentPageNumber + 1);

                      scroller.scrollTo(elementName, {
                        spy: true,
                        smooth: true,
                        offset: -100,
                        duration: 500,
                      });
                    } else {
                      generatePreviewsAtBottom();
                    }
                  }
                }}
                className={styles.confirm_button_yes}
              >
                はい
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
);

export default NewYearCard;
